package com.sddamico.draftmachine.models

import com.sddamico.draftmachine.data.Sport
import kotlinx.serialization.Serializable

/** Frontend mirror of the jvmMain `models/PlayerModels.kt` `PlayerResponse`. */
@Serializable
data class PlayerResponse(
  val id: String,
  val name: String,
  val sport: Sport,
  val position: String? = null,
  val team: String? = null,
  val teamShortName: String? = null,
  val adp: Double? = null,
  val adpPpr: Double? = null,
)
